export default __webpack_public_path__ + "static/media/7.062e0c12.png";